import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { stake } from '../../httpcalls/contractThunk';

import { updateMetaAuthHappening } from '../../store/schemas/authManagementSlice';
import Tilt from 'react-parallax-tilt';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import { useNavigate } from 'react-router-dom'
import AccordionComp from '../../components/global/accordion';
import CountComp from '../../components/global/counts';
import SectionText from '../../components/home/sectionText';
import ScanStrip from '../../components/global/scanStrip';
import NetworkButton from '../../components/global/networkButton';

const S_Onboarding = (props) => {
    const dispatch = useDispatch();
    const userActive = useSelector(state => state.authManagement.accounts[0])
    const network = useSelector(state => state.authManagement.network)
    const navigate = useNavigate()
    const currentSelectedChain = useSelector(state => state.mainapp.chainSlice.currentChain);

    return (
        <>
            <ScanStrip />

            <div className='hero-sectional'>
                <div className='on-intro vivify fadeIn duration-300'>
                    {/*   <div className='quick-links'>

                        <Link to='/faucet'>
                            Get PLURI via Faucet<i className='material-icons'>open_in_new</i>
                        </Link>
                    </div> */}

                    <div className='on-intro-text'>
                        <h1>Become a Pluri <span>Stakeholder</span>

                        </h1>
                        <p>Being a Pluri stakeholder
                            on the {currentSelectedChain.name} network
                            provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security.</p>
                    </div>

                    <div style={{ margin: '10px 0px' }} className='on-button'>

                        <NetworkButton classes={'hero-button'}>
                            <button onClick={(e) => { dispatch(stake()) }} className='hero-button'>Join Today</button>
                        </NetworkButton>



                    </div>
                    <p>21,000 Pluri Required</p>
                </div>
            </div>


            <CountComp
                /*  title={<h1>
                     Simple <span>Setup</span>
                 </h1>}
 
                 description={"Becoming a stakeholder is a simple process that requires you to get the required Pluri, stake it, and earn rewards."}
  */
                items={
                    [
                        {
                            value: "Get The Required Pluri",
                            description: "To become a stakeholder, you need to acquire 21,000 Pluri. You can get Pluri from the faucet or by purchasing it from an exchange.",
                            linkTitle: "Get Pluri via Faucet",
                            link: '/' + currentSelectedChain.slug + '/faucet'
                        },
                        {
                            value: "Stake Your Pluri",
                            description: "Once you have the required Pluri, you can stake it to become a stakeholder. Staking your Pluri will allow you to earn rewards. Learn more about tokenomics and epoch details in the next step.",

                        },
                        {
                            value: "Earn Rewards",
                            description: "As a stakeholder, you will earn rewards for staking your Pluri. The rewards will be automatically delivered to your wallet.",
                            linkTitle: "Tokenomics & Epoch Details",
                            link: '/' + currentSelectedChain.slug + '/tokenomics'
                        }
                    ]
                }
            />


            <AccordionComp
                /* title={<h1>What is <span>Pluri?</span></h1>}
                description={"Pluri Coin offers a way to connect data directly with transactional info on the blockchain. It provides benefits to developers by offloading database costs and simplifying payments, to investors by offering opportunities for staking and coin generation, and to ordinary users by ensuring data protection and freedom. Discover more with us."} */
                items={[
                    {
                        value: 'Why should I become a stakeholder?',
                        description: "Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security."
                    },
                    {
                        value: "What is Pluri?",
                        description: "Pluri Coin offers a way to connect data directly with transactional info on the blockchain. It provides benefits to developers by offloading database costs and simplifying payments, to investors by offering opportunities for staking and coin generation, and to ordinary users by ensuring data protection and freedom."
                    },
                    {
                        value: 'How do I earn rewards?',
                        description: "As a Pluri stakeholder, you will earn rewards for staking your Pluri. The rewards will be automatically delivered to your wallet. You can learn more about the rewards and how they are calculated in the tokenomics and epoch details."
                    },
                    {
                        value: 'How does unstaking work?',
                        description: "Unstaking your Pluri is a simple process that requires you to unstake your Pluri and wait for the unstaking period to end. Once the unstaking period ends, you can withdraw your Pluri and rewards from the staking contract."
                    }
                ]}

            />



            <style dangerouslySetInnerHTML={{
                __html: `
        .on-button >   .button { 
          padding: 13px 54px
        }

    
        `}} >
            </style>
        </>
    );
};

export default S_Onboarding;
